<template>
  <div class="letter-options">
    <div class="row" v-if="selectedDecoration">
      <div class="label">タイプ</div>
      <decorations :decorations="decorations"
                   :selectedDecoration="selectedDecoration"
                   @setDecoration="setDecoration" />
    </div>
    <div v-if="decoration_selected_flag && selectedDecoration.hasOwnProperty('pictures') && selectedDecoration.pictures.length">
      <div class="row">
        <div class="label">ロゴ</div>
        <pictures :pictures="selectedDecoration.pictures" :selectedPicture="selectedPicture" @setPicture="setPicture"></pictures>
      </div>
      <part :decoration_part="decoration_part" :selectedLetter="selectedLetter" :selectedDecoration="selectedDecoration"
            v-for="decoration_part in decoration_parts" :key="decoration_part.id"></part>
    </div>
    <div v-if="decoration_selected_flag && (!selectedDecoration.hasOwnProperty('pictures') || !selectedDecoration.pictures.length)">
      <div class="row">
        <div class="label">フォント</div>
        <fonts :fonts="fonts" :selectedFont="selectedFont" @setFont="setFont"></fonts>
      </div>
      <div class="row word_form_group">
        <div class="label">入力内容</div>
        <select class="word" v-model="word" v-if="selectedLetter.sync_code=='number'" @change="changeWord">
          <option v-for="n in 99">{{n}}</option>
        </select>
        <input class="word" v-model="word" v-else @change="changeWord">
      </div>
      <part :decoration_part="decoration_part" :selectedLetter="selectedLetter" :selectedDecoration="selectedDecoration"
             v-for="decoration_part in decoration_parts" :key="decoration_part.id"></part>
    </div>
  </div>
</template>

<script>
  import Fonts from './fontOptions/Fonts.vue'
  import Pictures from './logo/Picture.vue'
  import Decorations from './fontOptions/Decorations.vue'
  import Part from './fontOptions/Part.vue'
  import axios from 'axios/dist/axios.min'

  export default {
    name: 'letterOptions',
    components: {
      Fonts, Pictures, Decorations, Part
    },
    props: ['selectedLetter'],
    data(){
      return {
        decorations: [],
        selectedDecoration: null,
      }
    },
    computed: {
      decoration_parts(){
        if (this.selectedDecoration.outline_color_id){
          return [{name: '文字色'}, {name: '縁取り'}];
        } else {
          return [{name: '文字色'}];
        }
      },
      decoration_selected_flag(){
        return this.selectedDecoration != null && !this.selectedDecoration.is_constant;
      },
      fonts(){
        var fonts = [];
        for (var i = 0; i < this.$store.state.fonts.length; i++){
          if (this.$store.state.fonts[i].type == this.selectedLetter.type){
            fonts.push(this.$store.state.fonts[i]);
          }
        }
        return fonts;
      },
      colors(){
        return this.$store.state.colors;
      },
      selectedPicture:{
        get(){
          for (let i = 0; i < this.$store.state.cart.letters.length; i++){
            if (this.$store.state.cart.letters[i].id == this.selectedLetter.id){
              return this.$store.state.cart.letters[i].font;
            }
          }
        },
        set(value){
          // this.$store.commit('setCartLetterPicture', [this.selectedLetter, value]);
          this.$store.commit('setCartLetterFont', [this.selectedLetter, value]);
        }
      },
      selectedFont:{
        get(){
          for (let i = 0; i < this.$store.state.cart.letters.length; i++){
            if (this.$store.state.cart.letters[i].id == this.selectedLetter.id){
              return this.$store.state.cart.letters[i].font;
            }
          }
        },
        set(value){
          this.$store.commit('setCartLetterFont', [this.selectedLetter, value]);
        }
      },
      word: {
        get(){
          for (let i = 0; i < this.$store.state.cart.letters.length; i++){
            if (this.$store.state.cart.letters[i].id == this.selectedLetter.id){
              return this.$store.state.cart.letters[i].word;
            }
          }
        },
        set(value){
          this.$store.commit('setWord', {letter_id: this.selectedLetter.id, word: value});
        }
      },
    },
    methods: {
      setDecoration(decoration){
        this.selectedDecoration = decoration;
        this.$store.commit('setDecoration',{decoration:decoration, letter_id:this.selectedLetter.id});
        //文字装飾を選択するたびに最初のフォントが選択されるようにする
        if (decoration.hasOwnProperty('pictures') && decoration.pictures.length) {
          this.setPicture(decoration.pictures[0]);
        } else {
          this.setPicture(this.fonts[0]);
        }
      },
      setPicture(picture){
        if (!picture) picture;
        this.selectedPicture = picture;
      },
      setFont(font){
        if (!font) return;
        this.selectedFont = font;
        this.setSync();
      },
      setColor(color){
        this.$store.commit('setCartLetterColor', [this.selectedLetter, color]);
//        this.setSync();
      },
      setSync(){
        if (this.selectedLetter.sync_code){
          this.$emit('setSync', {
            selectedFont:this.selectedFont,
            word: this.word
          });
        }
      },
      changeWord(){
        if (this.selectedLetter.sync_code=='number'){
          this.$store.commit('setPackNumber', this.word);
        } else if (this.selectedLetter.sync_code=='name'){
          this.$store.commit('setPackName', this.word);
        }
        this.$store.commit('setWord',{word:this.word, letter_id:this.selectedLetter.id});
        this.setSync();
      }
    },
    created (){
      this.$store.commit('setLoading');
      const selectedLetter = this.$store.state.cart.letters.find(letter => letter.id === this.selectedLetter.id);
      axios.get('/letters/'+this.selectedLetter.id+'.json').then(response => {
        if (response.data.letter.decorations.length){
          for (let j = 0; j < response.data.letter.decorations.length; j++) {
            this.decorations.push(response.data.letter.decorations[j]);
          }
          // 値をセット
          if (selectedLetter.decoration) {
            this.selectedDecoration = selectedLetter.decoration;
          } else {
            this.selectedDecoration = response.data.letter.decorations[0];
          }
          // console.log(selectedLetter.decoration.name);
          this.setDecoration(this.selectedDecoration);
        }
        this.$store.commit('resetLoading');
      });
    },
  }
</script>

<style scoped>
  .word_form_group{
    text-align: center;
    height: 50px;
    background-color: #ffffff;
    border-bottom: 1px solid gray;
  }
  .word_form_group input{
    margin-top: 7px;
    height: 2.2rem;
    width: 90%;
    text-align: center;
  }
  .word{
    font-size: 16px;
    margin-top: 8px;
  }
  .row{
    height: 50px;
  }
  .label{
    display: flex;
    align-items: center;
    position: absolute;
    background-color: #fff;
    background-image: linear-gradient(#ffffff 90%, #c0c0c0);
    box-shadow: 3px 0 6px 0 rgba(0,0,0,0.4);
    width: 100px;
    height: 50px;
    float:left;
    border-bottom: 1px solid gray;
    border-right: 1px solid gray;
    vertical-align: middle;
    box-sizing: border-box;
    padding: 4px;
    z-index:2;
  }
</style>
